/* eslint-disable react/no-this-in-sfc */
import colors from "tailwindcss/colors";

export interface ColorTheme {
  color: string;
  lineColor: string;
}

export default function getColorThemeForIndex(index: number, theme: "light" | "dark" = "light"): ColorTheme {
  const color = theme === "light" ? 50 : 950;
  const lineColor = theme === "light" ? 600 : 400;
  const themes = [
    {
      color: colors.indigo[color],
      lineColor: colors.indigo[lineColor],
    },
    {
      color: colors.emerald[color],
      lineColor: colors.emerald[lineColor],
    },
    {
      color: colors.orange[color],
      lineColor: colors.orange[lineColor],
    },
    {
      color: colors.purple[color],
      lineColor: colors.purple[lineColor],
    },
    {
      color: colors.pink[color],
      lineColor: colors.pink[lineColor],
    },
    {
      color: colors.stone[color],
      lineColor: colors.stone[lineColor],
    },
  ];

  const resolvedTheme = themes[index % themes.length];
  return resolvedTheme;
}
